import ACTION from '../actionTypes';

const initialState = {
  data: [],
  form: {},
  loading: false,
  error: null,
  totalElements: 0,
};

export default function lotacao(state = initialState, action) {
  switch (action.type) {
    case ACTION.LOTACAO_GET_SEARCH_PAGE:
    case ACTION.LOTACAO_GET_ALL_REQUEST:
    case ACTION.LOTACAO_POST_REQUEST:
    case ACTION.LOTACAO_GET_ID_REQUEST:
    case ACTION.LOTACAO_UPDATE_REQUEST:
    case ACTION.LOTACAO_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTION.LOTACAO_GET_ALL_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case ACTION.LOTACAO_GET_SEARCH_PAGE_SUCCESS: {
      const { content, totalElements } = action.data;
      return {
        ...state,
        loading: false,
        error: null,
        data: (content || []).map(row => ({ ...row, key: row.id })),
        totalElements,
      };
    }
    case ACTION.LOTACAO_POST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ACTION.LOTACAO_UPDATE_SUCCESS:
    case ACTION.LOTACAO_GET_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        form: action.data,
      };
    case ACTION.LOTACAO_DELETE_SUCCESS:
      return {
        ...state,
      };
    case ACTION.LOTACAO_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
